module.exports = __webpack_public_path__ + "img/dash-card-arrow.6bd98087.svg";